/* Copyright (c) 2023, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

/**
 * Check the website below that has a better visualization on these easing functions
 * https://easings.net/en
 */

export function easeOutQuad(x: number): number {
    return 1 - (1 - x) * (1 - x);
}

export function easeInSine(x: number): number {
    return 1 - Math.cos((x * Math.PI) / 2);
}

export function easeInExpo(x: number): number {
    return x === 0 ? 0 : Math.pow(2, 10 * x - 10);
}

export function easeInOutCubic(x: number): number {
    return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
}

export function linear(x: number): number {
    return x;
}

export function easeOutCubic(x: number): number {
    return 1 - Math.pow(1 - x, 3);
}
